






































































import _ from "lodash";
import Vue from "vue";
import PlanBaseInfo from "@/views/plan/PlanBaseInfo.vue";
import Subjects from "@/views/plan/Subjects.vue";
import Introduction from "@/views/plan/Introduction.vue";
import { plan } from "@/api/plan";
import { enumI18nFormat, enumClassName, moneyFormat } from "@/utils/lang";
import { RegistrationStatus, YesOrNO } from "@/scripts/enums";
import ImService from "@/components/im/im-service.vue";

const DefaultCover = require("@/assets/plan-default-cover.png") as any;
const ItemMapper = (plan = {}) => {
    return {
        orgName: _.get(plan, "org.name", ""),
        cover: _.get(plan, "introduction.cover.thumbnailUrl", DefaultCover),
        fee: moneyFormat(_.get(plan, "setting.fee", 0)),
        introduction: _.get(plan, "introduction.introduction", ""),
        registrationStatus: enumI18nFormat("registrationStatusEnum", _.get(plan, "setting.registrationStatus")),
        registrationStatusClassName: enumClassName(_.get(plan, "setting.registrationStatus")),
        requiredAttachments: _.get(plan, "setting.requiredAttachments", "")
    };
};

export default Vue.extend({
    name: "PlanDetail",
    components: { PlanBaseInfo, Subjects, Introduction, ImService },
    props: {
        planId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            defaultCover: DefaultCover,
            plan: {},
            showLoginDialog: false,
            showAgreement: false,
            showPerfectDialog: false
        };
    },
    computed: {
        isImperfectRegistration(): boolean {
            return _.get(this.plan, "imperfectRegistration", true);
        },
        isEnableAgreement(): boolean {
            return _.get(this.plan, "setting.enableRegistrationAgreement", "") === YesOrNO.YES;
        },
        isProcessing(): boolean {
            return _.get(this.plan, "setting.registrationStatus", "") === RegistrationStatus.PROCESSING;
        },
        isDuplicateRegistration(): boolean {
            return _.get(this.plan, "duplicateRegistration", false);
        },
        item(): any {
            return ItemMapper(this.plan);
        },
        previewUrl(): string {
            return `/my/plans/${this.planId}/detail`;
        }
    },
    methods: {
        doSignUp() {
            if (!this.$store.getters["login/loggedIn"]) {
                this.showLoginDialog = true;
                return;
            }
            if (this.isImperfectRegistration) {
                this.showPerfectDialog = true;
                return;
            }
            if (this.isEnableAgreement) {
                this.showAgreement = true;
                return;
            }
            this.$router.push(`/plan/${this.planId}/registration`);
        }
    },
    mounted() {
        plan(this.planId as number).then(plan => {
            this.plan = plan;
        });
    }
});
